export const DEFAULT_LINE_HEIGHT = 1.3
